import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Item} from '@radix-ui/react-toggle-group';
import clsx from 'clsx';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';

type Props = React.ComponentProps<typeof Item> & {
  leadingIcon?: IconProp;
  trailingIcon?: IconProp;
};
export function ToggleGroupButton({
  leadingIcon,
  trailingIcon,
  className,
  ...props
}: Props): React.JSX.Element {
  return (
    <Item
      {...props}
      className={clsx(
        'relative inline-flex cursor-pointer items-center justify-center bg-slate1 px-3 py-2 text-sm font-semibold text-slate12 ring-1 ring-slate6 ring-inset hover:bg-slate3 focus-visible:z-10 focus-visible:bg-slate3 focus-visible:outline-hidden disabled:bg-slate2 disabled:text-slate11 radix-state-on:z-10 radix-state-on:bg-blue5 radix-state-on:ring-blue8',
        className
      )}
    >
      {leadingIcon && (
        <FontAwesomeIcon
          icon={leadingIcon}
          className="mr-2 text-slate11"
          aria-hidden="true"
        />
      )}
      {props.children}
      {trailingIcon && (
        <FontAwesomeIcon
          icon={trailingIcon}
          className="ml-2 text-slate11"
          aria-hidden="true"
        />
      )}
    </Item>
  );
}

ToggleGroupButton.displayName = 'ToggleGroupButton';
